import {Component, OnInit} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';
import {routePath} from 'sdv-common';
import {ApiService} from '../service/api.service';
import {ProjectService} from '../service/project.service';
import {keys, redirect} from '../shared/constants';

@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss']
})
export class ProjectComponent implements OnInit {

  project = {
    name: '',
    error: '',
    description: ''
  };

  constructor(private apiService: ApiService,
              public projectService: ProjectService,
              private cookieService: CookieService) {
    if (this.apiService.isAnonymous()) {
      redirect(routePath.login);
    }
  }

  ngOnInit() {
  }

  choseProject(id: string) {
    this.cookieService.set(keys.project, id);
    redirect('/dashboard?' + new URLSearchParams({
      $project: id
    }).toString());
  }
}
